import React, { useState } from 'react';
import { Button, Space, Table, TableProps, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { EditScoreDrawer } from 'components/drawer/evaluations/EditScoreDrawer';
import { IProfessorAreaAssessmentAttempts } from 'interfaces/professor_area/assessments';
import { ShowButton, TagField, TextField } from '@refinedev/antd';
import { evaluationsAttemptsStatus } from 'constants/admin/evaluations';
import { getStatusData } from 'services/professor_area/evaluations';
import { useParams } from 'react-router-dom';

interface Props {
  tableProps: TableProps<IProfessorAreaAssessmentAttempts>;
  refetch: () => void;
}

export const AttempsTable: React.FC<Props> = ({ tableProps, refetch }) => {
  const { id } = useParams();
  const [selectedAttempt, setSelectedAttempt] =
    useState<IProfessorAreaAssessmentAttempts | null>(null);

  return (
    <>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex={['user', 'full_name_or_name']}
          key="user_name"
          title="Aluno"
          sorter
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="registration"
          key="registration"
          title="Matrícula"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="pending_attempts"
          key="pending_attempts"
          title="Aguardando correção"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="corrected_attempts"
          key="corrected_attempts"
          title="Corrigido"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="total_attempts"
          key="total_attempts"
          title="Tentativas"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="status"
          key="status"
          title="Status"
          render={value => (
            <TagField
              color={getStatusData(value, evaluationsAttemptsStatus)?.color}
              value={getStatusData(value, evaluationsAttemptsStatus)?.label}
            />
          )}
        />
        <Table.Column
          dataIndex="score"
          key="score"
          title="Nota"
          render={value => <TextField value={value ?? '-'} />}
        />
        <Table.Column<IProfessorAreaAssessmentAttempts>
          title="Ações"
          dataIndex="actions"
          align="center"
          render={(_, record) => {
            return (
              <Space>
                <Tooltip title="Lançar nota">
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => setSelectedAttempt(record)}
                  />
                </Tooltip>
                <ShowButton
                  resource={'professor_area/classroom_assessments/attempts'}
                  recordItemId={record.id}
                  hideText
                  size="small"
                  meta={{
                    evaluationId: id
                  }}
                />
              </Space>
            );
          }}
        />
      </Table>

      <EditScoreDrawer
        attempt={selectedAttempt}
        open={!!selectedAttempt}
        onClose={() => setSelectedAttempt(null)}
        onSuccess={refetch}
      />
    </>
  );
};
